import type { LensPanelSection } from './panelTypes';

/** The Card destination's three tabs. Kept here (not in panelTypes.ts) since
 *  nothing outside LensEditPanel and this module needs to name one. */
export type EditorTab = 'data' | 'chart' | 'appearance';

export type InitialPanelTabArgs = {
  /** An undeclared dataset needs its source details in Data before editing. */
  isUndeclared: boolean;
  isNewCard: boolean | undefined;
  openSection: LensPanelSection | undefined;
  /** The raw sessionStorage read, including tabs from the former four-tab editor. */
  storedTab: string | null;
};

/**
 * Which tab the pane opens on. Old remembered Filters and Source tabs map to
 * Data; the old Visual tab maps to Chart, so returning authors keep their place.
 */
export function initialPanelTab({ isUndeclared, isNewCard, openSection, storedTab }: InitialPanelTabArgs): EditorTab {
  if (isUndeclared) {
    return 'data';
  }
  if (isNewCard) {
    return 'data';
  }
  if (openSection) {
    return openSection === 'data' ? 'data' : openSection === 'visual' ? 'chart' : 'appearance';
  }
  if (storedTab === 'chart' || storedTab === 'appearance') return storedTab;
  if (storedTab === 'style') return 'chart';
  return 'data';
}

/** The sessionStorage key the pane remembers its last tab under, scoped to
 *  one Lens so a habit formed editing one Lens's cards does not leak into a
 *  different Lens's freshly-pinned card. */
export function editorTabStorageKey(lensId: string | undefined): string {
  return `le-lens:editor-tab:v1:${lensId ?? 'unscoped'}`;
}
